<template>
  <div id="chooseDatasets">
    <div class="container-fluid pt-4">
      <div class="row">
        <div class="col-4">
          <DatasetPicker />
        </div><!-- /.col-6 -->
        <div
          class="col-4"
          v-if="$store.state.dataJoiner.chosenDatasets.length > 0"
        >
          <h2>Selected</h2>
          <div class="list-group">
            <a
              v-for="(dataset, i) in $store.state.dataJoiner.chosenDatasets"
              v-bind:key="i"
              @click="removeDataset(i)"
              class="list-group-item list-group-item-action clickable"
              v-bind:class="{ selected: dataset.selected }"
            >
              <div class="d-flex w-100 justify-content-between">
                <div class="card-right-group">
                  <small
                    v-if="dataset.selected === true"
                    v-b-tooltip.hover
                    title="Dataset selected"
                  >
                    <i class="fal fa-check-circle"></i>
                  </small>
                </div>
              </div>
              <p class="mb-1"><i class="fas fa-minus-circle text-danger"></i> {{ dataset.name }}<br><small>{{ dataset.description }}</small></p>
              <div
                v-if="dataset.headers"
                class="tags-container"
              >
                <span
                  v-for="(header, i) in dataset.headers"
                  v-bind:key="i"
                  class="badge badge-pill badge-primary mr-1"
                >
                  {{ header }}
                </span>
              </div><!-- /.tags-container -->
              <small>{{ dataset.createdOn | formatDate }}</small>
            </a>
          </div><!-- /.list-group -->
        </div><!-- /.col-4 -->
        <div
          class="col-4"
          v-if="$store.state.dataJoiner.chosenDatasets.length > 0"
        >
          <h2>Merge Headers <small>(Optional)</small></h2>

          <div class="list-group">
            <div
              v-for="(merge, index) in $store.state.dataJoiner.merges"
              v-bind:key="index"
              class="list-group-item"
            >
              <p><i class="fas fa-minus-circle text-danger clickable" @click="removeMerge(index)"></i> Merge {{ index + 1 }}</p>
              <p><strong>New Header Name:</strong> {{ merge.name }}</p>
              <p><strong>To Merge:</strong><span v-for="(mergeInOptions, ind) in merge.merges" v-bind:key="ind"><br><i class="fas fa-arrow-up"></i> {{ mergeInOptions.dataset + ' - ' + mergeInOptions.header }}</span></p>

              <b-btn
                size="sm"
                @click="editMerge(merge, index)"
              >Edit</b-btn>
            </div>

            <a
              @click="createMerge()"
              class="list-group-item list-group-item-action clickable"
            >
              <p class="text-center lead m-0"><i class="fas fa-plus-circle text-success"></i> Create Merge</p>
            </a>
          </div><!-- /.list-group -->
        </div>
      </div><!-- /.row -->
    </div><!-- /.container -->
    <!-- Stack / Join actions -->
    <div
      v-if="chosenDatasets.length > 1 && !$store.state.dataJoiner.spinner"
      id="actionBar"
    >
      <div class="dj-action clickable" @click="showStack = true">
        <span class="dj-action-title"><i class="fas fa-layer-group"></i> Stack {{ chosenDatasets.length }} Datasets</span>
        <small>One dataset with every point, labelled by source. For the same survey in different years.</small>
      </div>
      <div class="dj-action clickable" @click="joinDatasets">
        <span class="dj-action-title">Join {{ chosenDatasets.length }} Datasets <i class="fas fa-arrow-right"></i></span>
        <small>Lines up different measurements taken at the same coordinates.</small>
      </div>
    </div>

    <StackDatasets v-if="showStack" @close="showStack = false" />

    <CreateMerge v-if="$store.state.dataJoiner.showCreateMerge" />
    <PreviewExport v-if="$store.state.dataJoiner.showPreviewExport" />
  </div><!-- /#chooseDatasets -->
</template>

<script>
import moment from 'moment'
import firebase from 'firebase/compat/app'
import CreateMerge from './CreateMerge'
import DatasetPicker from './DatasetPicker'
import PreviewExport from './PreviewExport'
import StackDatasets from './StackDatasets'

export default {
  data () {
    return {
      allGeoJsonData: [], // Raw GeoJson files in one data object
      allJsonData: {}, // Joined to a master JSON object
      showStack: false
      // allJsonDataArray: [],
      // allHeaders: [] // Headers to be used in CSV
    }
  },
  components: {
    CreateMerge,
    DatasetPicker,
    PreviewExport,
    StackDatasets
  },
  computed: {
    selectedCount () {
      let count = 0
      this.$store.state.dataJoiner.chosenDatasets.forEach(item => {
        if (item.selected) {
          count++
        }
      })
      return count
    },
    allJsonDataArray: {
      get () {
        return this.$store.state.dataJoiner.allJsonDataArray
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'allJsonDataArray', value: value })
      }
    },
    allHeaders: {
      get () {
        return this.$store.state.dataJoiner.allHeaders
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'allHeaders', value: value })
      }
    },
    datasets: {
      get () {
        return this.$store.state.dataJoiner.datasets
      },
      set (value) {
        this.$store.commit('dataJoiner/setDatasets', value)
      }
    },
    editMode: {
      get () {
        return this.$store.state.dataJoiner.editMode
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'editMode', value: value })
      }
    },
    merge: {
      get () {
        return this.$store.state.dataJoiner.merge
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'merge', value: value })
      }
    },
    mergeIndex: {
      get () {
        return this.$store.state.dataJoiner.mergeIndex
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'mergeIndex', value: value })
      }
    },
    merges: {
      get () {
        return this.$store.state.dataJoiner.merges
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'merges', value: value })
      }
    },
    chosenDatasets: {
      get () {
        return this.$store.state.dataJoiner.chosenDatasets
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'chosenDatasets', value: value })
      }
    },
    showCreateMerge: {
      get () {
        return this.$store.state.dataJoiner.showCreateMerge
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'showCreateMerge', value: value })
      }
    }
  },
  methods: {
    processNewFile () {
      for (let i = 0; i < this.allGeoJsonData.length; i++) {
        this.allGeoJsonData[i].features.forEach(feature => {
          const lon = feature.geometry.coordinates[0]
          const lat = feature.geometry.coordinates[1]
          const uniqueId = lon.toString() + lat.toString()
          // If this uniqueId exists, just add the data. Otherwise, create new row item
          if (Object.prototype.hasOwnProperty.call(this.allJsonData, uniqueId)) {
            this.allJsonData[uniqueId][this.allGeoJsonData[i].headerName] = feature.properties[this.allGeoJsonData[i].header]
          } else {
            this.allJsonData[uniqueId] = {
              longitude: lon,
              latitude: lat
            }
            this.allHeaders.forEach(headerItem => {
              // this.allJsonData[uniqueId][headerItem] = '-'
              this.allJsonData[uniqueId][headerItem] = false
            })
            this.allJsonData[uniqueId][this.allGeoJsonData[i].headerName] = feature.properties[this.allGeoJsonData[i].header]
          }
        })
      }

      // Loop through jsonData object and turn into an array
      const allJsonDataKeys = Object.keys(this.allJsonData)
      allJsonDataKeys.forEach(key => {
        this.allJsonDataArray.push(this.allJsonData[key])
      })

      if (this.merges.length > 0) {
        this.allJsonDataArray.forEach(uniquePoint => {
          for (let i = this.merges.length - 1; i >= 0; i--) {
            const merge = this.merges[i]
            const newHeaderName = merge.name
            for (let me = merge.merges.length - 1; me >= 0; me--) {
              const thisMerge = merge.merges[me]
              const headerName = thisMerge.header + '_' + thisMerge.dataset
              // if (uniquePoint[headerName] !== '-') {
              if (uniquePoint[headerName] !== false) {
                uniquePoint[newHeaderName] = uniquePoint[headerName]
              }
            }
          }
        })
      }

      // // Functions for generating CSV File
      // function convertToCSV (objArray) {
      //   let array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray
      //   let str = ''
      //   for (let i = 0; i < array.length; i++) {
      //     let line = ''
      //     for (let index in array[i]) {
      //       if (line !== '') line += ','
      //       line += array[i][index]
      //     }
      //     str += line + '\r\n'
      //   }
      //   return str
      // }
      // function exportCSVFile (headers, items, fileTitle) {
      //   if (headers) {
      //     items.unshift(headers)
      //   }
      //   // Convert Object to JSON
      //   let jsonObject = JSON.stringify(items)
      //   let csv = convertToCSV(jsonObject)
      //   let exportedFilenmae = fileTitle + '.csv' || 'export.csv'
      //   let blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      //   if (navigator.msSaveBlob) { // IE 10+
      //     navigator.msSaveBlob(blob, exportedFilenmae)
      //   } else {
      //     let link = document.createElement('a')
      //     if (link.download !== undefined) { // feature detection
      //       // Browsers that support HTML5 download attribute
      //       let url = URL.createObjectURL(blob)
      //       link.setAttribute('href', url)
      //       link.setAttribute('download', exportedFilenmae)
      //       link.style.visibility = 'hidden'
      //       document.body.appendChild(link)
      //       link.click()
      //       document.body.removeChild(link)
      //     }
      //   }
      // }
      // let headers = {
      //   longitude: 'longitude',
      //   latitude: 'latitude'
      // }
      // this.allHeaders.forEach(head => {
      //   headers[head] = head
      // })
      // this.merges.forEach(merge => {
      //   headers[merge.name] = merge.name
      // })

      const headers = {
        longitude: 'longitude',
        latitude: 'latitude'
      }
      this.allHeaders.forEach(head => {
        headers[head] = head
      })
      // this.merges.forEach(merge => {
      //   headers[merge.name] = merge.name
      // })

      for (let i = this.merges.length - 1; i >= 0; i--) {
        const merge = this.merges[i]
        headers[merge.name] = merge.name
      }

      this.allJsonDataArray.unshift(headers)

      this.$store.commit('dataJoiner/setStateProperty', { property: 'showPreviewExport', value: true })

      // let fileTitle = 'joined_datasets' // or 'my-unique-title'
      // exportCSVFile(headers, this.allJsonDataArray, fileTitle) // call the exportCSVFile() function to process the JSON and trigger the download
      this.$store.commit('dataJoiner/setSpinner', false)
    },
    joinDatasets () {
      // Join works column by column, so a dataset with no data columns
      // (a location-only collector, for example) contributes nothing and
      // the result used to be an empty dataset. Say so and point to Stack.
      const columnless = this.chosenDatasets.filter(d => !d.headers || d.headers.length === 0)
      if (columnless.length) {
        this.$store.commit('setAlert', {
          active: true,
          message: `${columnless.map(d => `"${d.name}"`).join(', ')} ${columnless.length === 1 ? 'has' : 'have'} no data columns to join, only locations. To combine datasets like these, use Stack instead.`,
          level: 'alert-warning',
          timeout: 12000
        })
        return
      }
      // Make sure all data is cleared
      this.allGeoJsonData = []
      this.allHeaders = []
      this.allJsonData = {}
      this.allJsonDataArray = []
      this.$store.commit('dataJoiner/setSpinner', true)
      const self = this
      // Get all geoJson data
      const getGeoJsonPromises = []

      async function getGeoJson (geoJsonPath, datasetName, datasetHeader) {
        // Load the GeoJSON straight from Storage with an authenticated
        // download URL — replaces the legacy api.efficientvineyard.com
        // geoJsonURL property that no longer exists on datasets.
        const url = await firebase.storage().ref(geoJsonPath).getDownloadURL()
        const response = await fetch(url)
        const datasetDataObj = await response.json()
        datasetDataObj.name = datasetName
        datasetDataObj.header = datasetHeader
        datasetDataObj.headerName = datasetHeader + '_' + datasetName
        self.allGeoJsonData.push(datasetDataObj)
        self.allHeaders.push(datasetDataObj.headerName)
      }

      this.chosenDatasets.forEach(dataset => {
        const path = dataset.file && (dataset.file.geoJsonPath || dataset.file.path)
        dataset.headers.forEach(header => {
          const getGeoJsonPromise = getGeoJson(path, dataset.name, header)
          getGeoJsonPromises.push(getGeoJsonPromise)
        })
      })

      Promise.all(getGeoJsonPromises).then(() => {
        this.processNewFile()
      })
    },
    removeDataset (i) {
      console.log('Remove ' + i)
      this.chosenDatasets.splice(i, 1)
      this.merges = []
    },
    removeMerge (i) {
      console.log('Remove ' + i)
      this.merges.splice(i, 1)
    },
    createMerge () {
      console.log('Create Merge')
      this.editMode = false
      this.showCreateMerge = true
    },
    editMerge (merge, index) {
      this.merge = merge
      this.mergeIndex = index
      this.editMode = true
      this.showCreateMerge = true
    }
  },
  filters: {
    formatDate (val) {
      if (!val) return '-'
      // Firestore Timestamps from the client SDK expose toDate(); the
      // server-shape (REST-style) uses _seconds. Handle both.
      let date
      if (typeof val.toDate === 'function') date = val.toDate()
      else if (val._seconds != null) date = new Date(val._seconds * 1000)
      else if (val.seconds != null) date = new Date(val.seconds * 1000)
      else date = new Date(val)
      return moment(date).format('MM/DD/YY')
    }
  }
}
</script>

<style scoped>
#chooseDatasets {
  margin-bottom: 100px;
}

.selected {
  background-color: #c3e6cb;
}

.selected:hover {
  background-color: #c3e6cb;
  opacity: 0.9;
}

#actionBar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 1;
  box-shadow: 1px -2px 6px rgba(0,0,0,0.1);
}

.dj-action {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 14px 12px;
  background-color: #c3e6cb;
  transition: background-color 0.2s ease-in-out;
}

.dj-action + .dj-action {
  border-left: 1px solid rgba(0,0,0,0.1);
}

.dj-action:first-child {
  background-color: #d8eedf;
}

.dj-action:hover {
  background-color: #b1dfbb;
}

.dj-action-title {
  font-size: 24px;
  line-height: 1.2;
}

.dj-action small {
  color: #355e3b;
  margin-top: 2px;
}
</style>
